// 默认江门产业分类
let industryList = [
  {
    label: '新一代信息技术产业',
    value: '1'
  },
  {
    label: '新能源汽车产业',
    value: '2'
  },
  {
    label: '生物医药产业',
    value: '3'
  },
  {
    label: '战略性产业集群',
    value: '4'
  }
]

let industryLists = [
  {
    name: '战略性产业集群',
    value: '4',
    key: '4'
  },
  {
    name: '新一代信息技术产业',
    value: '1',
    key: '1'
  },
  {
    name: '新能源汽车产业',
    value: '2',
    key: '2'
  },
  {
    name: '生物医药产业',
    value: '3',
    key: '3'
  }
]
// let key = process.env.VUE_APP_KEY
// if (key === 'foShan') {
//   // 佛山
//   industryList = [
//     { label: '高端装备制造产业', value: '1' },
//     { label: '前沿新材料产业', value: '2' },
//     { label: '安全应急与环保产业', value: '3' }
//   ]
//   industryLists = [
//     { name: '高端装备制造产业', value: '1', key: '1' },
//     { name: '前沿新材料产业', value: '2', key: '2' },
//     { name: '安全应急与环保产业', value: '3', key: '3' }
//   ]
// }

const key = process.env.VUE_APP_KEY
function dynamicSwitchIndustryList() {
  if (key === 'zhongshan') {
    const industryList = [
      {
        label: '生物药品产业',
        value: '1'
      },
      {
        label: '智能照明产业',
        value: '2'
      },
      {
        label: '智能安防产业',
        value: '3'
      },
      {
        label: '工业机器人产业',
        value: '4'
      },
      {
        label: '智能家电产业',
        value: '5'
      }
    ]
    const industryLists = industryList.map((i) => {
      return {
        value: i.value,
        name: i.label,
        key: i.value
      }
    })
    return {
      industryList,
      industryLists
    }
  } else {
    return {
      industryList,
      industryLists
    }
  }
}

module.exports = {
  ...dynamicSwitchIndustryList()
}
